import { useState } from 'react';

import { Button, Dialog, Field, Select } from '../../../../components/ui';
import { useLoi } from '../../../../hooks/useLoi';
import { useT } from '../../../../i18n';
import { useToast } from '../../../../lib/toast';
import { LoiTrongHop } from '../../../tenant/components/phan-form';
import { useGanCho } from '../../hooks/useCauHinhLoi';
import type { CodeLoi, MucCho } from '../../types';

/** Gán một exception chờ vào code có sẵn: nó thành dòng chi tiết mới của code đó, khớp mọi thông điệp. */
export function HopGanCho({
  cho,
  codes,
  onClose,
  onDaGan,
}: {
  cho: MucCho;
  codes: CodeLoi[];
  onClose: () => void;
  onDaGan: (code: string) => void;
}) {
  const { t } = useT();
  const toast = useToast();
  const dichLoi = useLoi();
  const gan = useGanCho();
  const [code, setCode] = useState('');
  const [thieu, setThieu] = useState(false);

  const gui = () => {
    if (!code) {
      setThieu(true);
      return;
    }
    gan.mutate(
      { id: cho.id, code },
      {
        onSuccess: () => {
          toast.success(t('rpaLoi.gan.daGan', { ma: code }));
          onDaGan(code);
          onClose();
        },
      },
    );
  };

  return (
    <Dialog
      open
      onClose={onClose}
      width={520}
      destroyOnHidden
      title={t('rpaLoi.gan.tieuDe')}
      footer={
        <div className="space-y-3">
          {gan.error && <LoiTrongHop>{dichLoi(gan.error)}</LoiTrongHop>}
          <div className="flex flex-wrap justify-end gap-3">
            <Button variant="outline" size="md" onClick={onClose}>
              {t('chung.huy')}
            </Button>
            <Button variant="primary" size="md" loading={gan.isPending} onClick={gui}>
              {gan.isPending ? t('chung.dangLuu') : t('rpaLoi.gan.gan')}
            </Button>
          </div>
        </div>
      }
    >
      <div className="space-y-4 pt-2">
        <div className="rounded-lg border border-default bg-subtle px-3 py-2.5 text-xs">
          <p className="break-all font-mono text-sm text-content-primary">{cho.exception}</p>
          {cho.sampleMessage && <p className="mt-1 break-words text-content-secondary">{cho.sampleMessage}</p>}
        </div>
        <Field label={t('rpaLoi.gan.code')} required hint={t('rpaLoi.gan.codeGoiY')} error={thieu ? t('rpaLoi.gan.loiChon') : undefined}>
          {(p) => (
            <Select<string>
              {...p}
              autoFocus
              showSearch={{ optionFilterProp: 'label' }}
              className="w-full"
              status={p['aria-invalid'] ? 'error' : undefined}
              value={code || undefined}
              placeholder={t('rpaLoi.gan.codeChon')}
              onChange={(v) => {
                setCode(v);
                setThieu(false);
                gan.reset();
              }}
              options={codes.map((c) => ({ value: c.code, label: `${c.code} · ${c.name}` }))}
            />
          )}
        </Field>
      </div>
    </Dialog>
  );
}
